// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"0f9a395e","621":"e705f5d9","743":"408dc7b5","881":"2501d4fe","917":"e604d91e"}[chunkId] + ".chunk.js";
};